
import {makeStyles} from '@material-ui/core/styles'
import {colors} from '../../../shared/colors'

const useStyles = makeStyles( theme => ({
    message:{
        fontSize: '2rem',
        fontWeight: 'bold',
        lineHeight: 2,
        wordBreak: 'break-word',
        [theme.breakpoints.down('md')]:{
            lineHeight: 'unset',
            padding: '1.3rem',
            maxWidth: '70%'
        }
    },
    checkIcon:{
        color: colors.magellanDeepGreen,
        transform: 'scale(3.3)',
    },
    checkIconWrapper: {
        paddingBottom: '1.5rem'
    },
    buttonWrapper:{
        margin: "20px 0",
        [theme.breakpoints.down('md')]:{
            padding: '2rem'
        },
    }
}))

export default useStyles;
